"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _Theme = require("../Theme");

var _Box = _interopRequireDefault(require("../Box"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _core = require("@emotion/core");

var _GridDebugger = _interopRequireDefault(require("../GridDebugger"));

var _NotificationSystem = require("../NotificationSystem");

var __jsx = _react["default"].createElement;

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            position: absolute;\n            z-index: 10001;\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            position: absolute;\n            top: 0;\n            left: 0;\n            z-index: 10000;\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            position: relative;\n            z-index: 0;\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            body.ReactModal__Body--open {\n              overflow-y: hidden;\n            }\n          "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = function _default(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  var offset = (0, _NotificationSystem.getNotificationOffset)(theme);
  return (0, _core.jsx)(_Theme.ThemeProvider, {
    theme: theme
  }, (0, _core.jsx)(_NotificationSystem.NotificationSystemProvider, null, (0, _core.jsx)(_GridDebugger["default"], null), (0, _core.jsx)(_core.Global, {
    styles: (0, _core.css)(_templateObject())
  }), (0, _core.jsx)("div", {
    css: (0, _core.css)(_templateObject2()),
    id: "__app__"
  }, children), (0, _core.jsx)("div", {
    css: (0, _core.css)(_templateObject3()),
    id: "__layers__"
  }), (0, _core.jsx)("div", {
    css: (0, _core.css)(_templateObject4()),
    id: "__notifications__"
  }, (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      top: offset.top.y,
      left: offset.top.x,
      width: theme.space.notificationSystemWidth,
      display: ["none", null, "block"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-topLeft__"
  })), (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      top: offset.top.y,
      right: offset.top.x,
      width: theme.space.notificationSystemWidth,
      display: ["none", null, "block"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-topRight__"
  })), (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      top: offset.top.y,
      right: offset.top.x,
      left: offset.top.x,
      display: ["block", null, "none"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-topMobile__"
  })), (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      bottom: offset.top.y,
      left: offset.top.x,
      width: theme.space.notificationSystemWidth,
      display: ["none", null, "block"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-bottomLeft__"
  })), (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      bottom: offset.top.y,
      right: offset.top.x,
      width: theme.space.notificationSystemWidth,
      display: ["none", null, "block"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-bottomRight__"
  })), (0, _core.jsx)(_Box["default"], {
    sx: {
      position: "fixed",
      bottom: offset.top.y,
      right: offset.top.x,
      left: offset.top.x,
      display: ["block", null, "none"]
    }
  }, (0, _core.jsx)(_Grid["default"], {
    cols: 1,
    gap: "notificationSystemSeparator",
    id: "__notifications-bottomMobile__"
  })))));
};

exports["default"] = _default;